<template>
    <svg
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
      :style="color ? { color } : {}"
    >
      <!-- fill uses currentColor, which now comes from CSS class or inline style -->
      <path :d="path" fill="currentColor" />
    </svg>
  </template>
  
  <script>
  export default {
    name: "SvgIcon",
    props: {
      path:  { type: String, required: true },
      size:  { type: [Number, String], default: 24 },
      // only used if you pass a color prop; otherwise CSS classes win
      color: { type: String, default: null },
    },
  };
  </script>